export const DEMERIT_EDUCATION_GA_SCREEN = {
  RESERVATION__STEP_1_CHECK: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION__STEP_1_CHECK',
  RESERVATION__STEP_2_BRANCH: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION__STEP_2_BRANCH',
  RESERVATION__STEP_3_PERIOD: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION__STEP_3_PERIOD',
  RESERVATION__STEP_4_CENTER: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION__STEP_4_CENTER',
  RESERVATION__STEP_5_TIME: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION__STEP_5_TIME',
  RESERVATION_EDIT__STEP_1_CHECK: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION_EDIT__STEP_1_CHECK',
  RESERVATION_EDIT__STEP_2_BRANCH: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION_EDIT__STEP_2_BRANCH',
  RESERVATION_EDIT__STEP_3_PERIOD: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION_EDIT__STEP_3_PERIOD',
  RESERVATION_EDIT__STEP_4_CENTER: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION_EDIT__STEP_4_CENTER',
  RESERVATION_EDIT__STEP_5_TIME: 'PUBLIC_SERVICE_DEMERIT_EDUCATION_RESERVATION_EDIT__STEP_5_TIME',
} as const;
